(function ($) {
    /**
     * This this a faster way to replace HTML content than jQuery's default $.html(...).
     * It destroys old children async, but inserts content immediately.
     * @param {String} val
     * @returns {jQuery}
     */
    $.fn.htmlReplace = function (html) {
        return this.each(function (i, el) {
            // Hacky function to prevent memory leaks by killing nodes separately
            setTimeout(function($nodes) {
                return function () {
                    $nodes.remove();
                };
            }($(el).children()), 10);

            // Fast way to set HTML
            el.innerHTML = html;

            return el;
        });
    };
})(jQuery);
